import { Field, TextInput, TextArea, SectionCard, ListAddBtn, ListRemoveBtn } from "./_shared";

const ICONS = ["check", "user", "video", "apple", "message", "calendar", "users"];

export default function EditIncluded({ value, onChange }) {
  const set = (k, v) => onChange({ ...value, [k]: v });
  const setItem = (i, key, v) => {
    const items = [...(value.items || [])];
    items[i] = { ...items[i], [key]: v };
    set("items", items);
  };
  const addItem = () => set("items", [...(value.items || []), { title: "Novo benefício", description: "", icon: "check" }]);
  const removeItem = (i) => set("items", (value.items || []).filter((_, idx) => idx !== i));

  return (
    <SectionCard title="O Que Está Incluído">
      <div className="space-y-5">
        <Field label="Overline"><TextInput value={value.overline} onChange={(v) => set("overline", v)} testId="included-overline-input" /></Field>
        <Field label="Título"><TextInput value={value.title} onChange={(v) => set("title", v)} testId="included-title-input" /></Field>
        <Field label="Subtítulo"><TextArea value={value.subtitle} onChange={(v) => set("subtitle", v)} rows={2} testId="included-subtitle-input" /></Field>

        <div>
          <div className="flex items-center justify-between mb-3">
            <span className="text-xs tracking-[0.2em] uppercase text-onyx/60">Itens</span>
            <ListAddBtn onClick={addItem} label="Adicionar item" testId="included-add-item" />
          </div>
          <div className="space-y-4">
            {(value.items || []).map((it, i) => (
              <div key={i} data-testid={`included-row-${i}`} className="border border-border p-4 space-y-3">
                <div className="grid sm:grid-cols-3 gap-3">
                  <Field label="Ícone">
                    <select
                      data-testid={`included-icon-${i}`}
                      value={it.icon || "check"}
                      onChange={(e) => setItem(i, "icon", e.target.value)}
                      className="w-full px-3 py-2.5 border border-border bg-white text-onyx text-sm focus:outline-none focus:border-gold"
                    >
                      {ICONS.map((ic) => <option key={ic} value={ic}>{ic}</option>)}
                    </select>
                  </Field>
                  <div className="sm:col-span-2"><Field label="Título"><TextInput value={it.title} onChange={(v) => setItem(i, "title", v)} testId={`included-title-${i}`} /></Field></div>
                </div>
                <Field label="Descrição"><TextArea value={it.description} onChange={(v) => setItem(i, "description", v)} rows={2} testId={`included-description-${i}`} /></Field>
                <div className="flex justify-end"><ListRemoveBtn onClick={() => removeItem(i)} testId={`included-remove-${i}`} /></div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </SectionCard>
  );
}
